import { getAPIUrl } from '../global';
import { Get, Post, Put, Remove } from '../headerIntercepter';

export const createInvitation = (data,params) => {
  const url = getAPIUrl('organization.invitationCreate',params);
  return Post(url, data, true);
};
export const createOpenLinkInvitation = (data,params) => {
  const url = getAPIUrl('organization.openLinkCreate',params);
  return Post(url, data, true);
};
export const OpenLinkInvitationOtp = (data,params) => {
  const url = getAPIUrl('organization.openLinkInvitationotp',params);
  return Post(url, data, true);
};

export const getAllInvitation = (params={},query={}) => {
    const url = getAPIUrl('organization.invitation',params);
    return Get(url, true,query);
  };
